'use client';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const NOTE = 'Note: If your device has physical damage or short circuit, you can still get it repaired, but it will be handled as an out-of-warranty repair and you will be charged for parts and labor.';

export const TechnicalDetailsTable = ({ data = [] }) => {
    return (
        <>
            <DataTable value={data} stripedRows>
                <Column field="title" header="Specification" />
                <Column field="value" header="Details" />
            </DataTable>
        </>
    );
};
